export const paletteOptions = {
  error: {
    main: '#fe5d5d'
  },
  background: {
    default: '#F7F6F2',
    paper: '#FFFFFF'
  },
  primary: {
    main: '#8f8e8a'
  },
  'transparency-0': '0%',
  'transparency-100': '10%',
  'transparency-200': '20%',
  'transparency-300': '30%',
  'transparency-400': '40%',
  'transparency-500': '50%',
  'transparency-600': '60%',
  'transparency-700': '70%',
  'transparency-800': '80%',
  'transparency-900': '90%',

  // Base
  'base-white': '#ffffff',
  'base-black': '#000000',

  'sage-50': '#f7f6f2',
  'sage-100': '#e5e4df',
  'sage-200': '#cac9c4',
  'sage-300': '#adaca8',
  'sage-400': '#8f8e8a',
  'sage-500': '#72716d',
  'sage-600': '#565551',
  'sage-700': '#3c3b37',
  'sage-800': '#272725',
  'sage-900': '#171715',

  'accent-100': '#defef8',
  'accent-200': '#befef7',
  'accent-300': '#9cfefb',
  'accent-400': '#86f8fe',
  'accent-500': '#5deafe',
  'accent-600': '#44bbda',
  'accent-700': '#2f90b6',
  'accent-800': '#1e6793',
  'accent-900': '#114b79',

  'green-100': '#f7fede',
  'green-200': '#edfebd',
  'green-300': '#e2fe9d',
  'green-400': '#d3fe85',
  'green-500': '#c0fe5d',
  'green-600': '#9ada43',
  'green-700': '#77b62d',
  'green-800': '#59931e',
  'green-900': '#417912',

  'orange-100': '#fef8de',
  'orange-200': '#ffefbe',
  'orange-300': '#fee39d',
  'orange-400': '#fed886',
  'orange-500': '#fec65e',
  'orange-600': '#daa045',
  'orange-700': '#b67d2e',
  'orange-800': '#935d1d',
  'orange-900': '#794612',

  'red-100': '#ffe9de',
  'red-200': '#fecfbe',
  'red-300': '#feae9d',
  'red-400': '#fe8f85',
  'red-500': '#fe5d5d',
  'red-600': '#da4351',
  'red-700': '#b62e47',
  'red-800': '#931d3c',
  'red-900': '#791135'
}
